import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={10.018}
    height="6.8mm"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 3962 10163"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#333}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974325549056">
        <path
          d="M2734 6922H1226v1376h1508V6922zM566 2846h2830v-865c0-388-159-742-416-999-257-258-611-416-999-416-390 0-742 158-999 416-258 256-416 611-416 999v865zm2830 1008H566v1654c0 224 52 437 146 625 90 180 216 338 370 466h1798c153-128 280-286 370-466 93-188 146-401 146-625V3854zM566 3530h2830v-361H566v361zm1264 5091v1381c0 88-72 161-162 161-88 0-162-73-162-161V8621h-442c-88 0-162-72-162-162V6869c-199-159-365-362-480-594s-179-492-179-767V1981c0-478 194-913 510-1228 315-314 750-510 1228-510s913 196 1228 510c314 315 510 750 510 1228v3527c0 275-65 535-180 767s-280 435-481 594v1590c0 90-72 162-162 162h-442v1381c0 88-72 161-162 161-88 0-162-73-162-161V8621h-300z"
          className="fil0"
        />
        <path
          d="M2551 599c-175-74-367-114-570-114s-396 40-570 114c-183 75-349 187-487 325-138 140-250 304-327 487-72 174-112 368-112 570v3527c0 117 13 230 38 338 27 113 67 221 117 323 48 99 110 193 178 277 67 81 142 156 224 225 64 43 103 115 103 198v1509h361c63 0 121 24 162 63 43-39 101-63 162-63h300c63 0 121 24 162 63 43-39 101-63 162-63h361V6869h2c0-71 30-143 92-189 86-70 165-150 235-234 68-84 129-178 178-277 50-102 90-210 117-323 25-108 37-221 37-338V1981c0-202-39-396-113-570-75-183-187-347-325-487-140-138-304-250-487-325zM1981 0c266 0 521 54 757 151 242 101 460 248 643 430 182 183 329 401 430 643 97 236 151 491 151 757v3527c0 153-18 304-52 449-34 147-86 291-153 426-66 131-146 254-237 369-67 81-141 158-220 228v1479c0 112-45 212-118 286-74 74-175 119-286 119H1064c-111 0-212-45-286-119-7-7-12-14-18-21-62-70-100-164-100-265V6980c-78-70-151-146-218-228-91-115-171-238-237-369-67-135-119-279-153-426-34-145-52-296-52-449V1981c0-266 52-521 151-757 101-243 248-460 430-643 183-182 401-329 643-430C1458 54 1715 0 1981 0z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
